export default __webpack_public_path__ + "img/48c9d343664b609591771ef37044c365.svg";